<template>
    <div class="page-list page-list-comment">
        <wz-comment-list obj-type="10" obj-id="1" :pageNum="100" :params="{time:uptime,place:place}"></wz-comment-list>
        <div class="comment-foot">
			<van-button v-if="!myUid" type="danger" :block="true" x-click="go.login">点击登录</van-button>
            <wz-comment-post v-else obj-type="10" obj-id="1" @success="postOk"></wz-comment-post>
        </div>        
    </div>
</template>
<script>
	import {mapGetters} from 'vuex'
    export default {
        data() {
            return {
                uptime : 0,
                postTimer : null,
                timerLoop : 10000,
                place : ""
            }
        },
		computed:{
			...mapGetters(['myUid'])
		},
        methods: {
            postOk(){
                this.update({
                    place : "post"
                })
            },
            update(args){
                this.uptime = new Date().getTime()
                if(args && args.place){
                    this.place = args.place
                }
               /*this.postTimer = setTimeout(()=>{
                    this.update({place:"timer"})
                }, this.timerLoop)*/

            }
        },
        created() {
            //this.update()
        },
        beforeDestroy(){
            clearTimeout(this.timerLoop)
            this.timerLoop = null
        }
    }
</script>